import { Box, Button, CircularProgress, FormControl, Typography, withStyles } from "@material-ui/core";
import React, { useReducer, useState } from "react";
import { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect } from "react-redux";
import SetPin from "../2FA/SetPin";
import Styles from "../commonStyles";
import { validatePassword } from "../validation/validator";
import { alertActions } from "../_actions";
import AuthContainer from "../_components/AuthContainer";
import CommonPopup from "../_components/CommonPopup";
import { Event } from "../_components/Event";
import InputPaper from "../_components/InputPaper";
import config from "../_config/config";
import strings from "../_constants/strings";
import actions from "../_fpactions/fpswdactions";
import { deleteCookie, setReferer } from "../_helpers/cookies";
import axios from "../_helpers/interceptor";
import { goToLogin } from "../_helpers/navHelpers";
import useEventCallback from "../_helpers/useEventCallBack";
import ChangepassForm from "./ChangpassForm";
import OtpForm from "./Otpform";
import { CssOutlinedInput } from "../_components/Input";

const otpSuccessEvent = new Event("OTP_SUCCESS");
const otpErrorEvent = new Event("OTP_ERROR");

const initialState = {
  step: 0,
  user: null,
  username: "",
  // username: props.match.params.username,
  otp: "",
  newpassword: "",
  confirmpassword: "",
  token: "",
  error: {},
  isSendOtp: false,
  isSubmitpassword: false,
  popup: false,
  otpToken: "",
  showPassword: false,
  captchaState: null,
};

function makeCall(data, url, headers) {
  var dt = {
    payload: [data]
  };
  if (url) {
    return axios.post(`${url}`, dt, headers || {});
  }
  return axios.post(`${config.endpoint}${config.fgtPwd}`, dt, headers || {});
}

function reducerFunction(state, action) {
  const { ERRORS: { E_VALID_USER_ID, E_VALID_OTP, E_PASSWORD_MATCH, E_PASSWORD_CHECK } } = strings;
  let error;
  switch (action.type) {
    //Stage 1: Enter Username
    case actions.USERNAME_EDIT:
      error = !(action.data && action.data.length <= 25);

      return {
        ...state,
        username: action.data,
        googleCaptchaVal: action.googleCaptchaVal,
        error: {
          username: error ? E_VALID_USER_ID : '',
          msg: ''
        },
      };
    case actions.USER_ID_SUBMIT:
      error = !(state.username && state.username.length <= 25);
      const captchaError = !state.captchaState;
      const googleCaptchaError = !state.googleCaptchaVal || state.googleCaptchaVal == '';

      return {
        ...state,
        submitting: !error /* && !captchaError */ && !googleCaptchaError,
        error: {
          username: error ? E_VALID_USER_ID : googleCaptchaError ? 'Complete CAPTCHA' : ''
          // username: error ? E_VALID_USER_ID : captchaError ? 'Complete CAPTCHA' : ''
          // username: error ? E_VALID_USER_ID : ''
        },
      }
    case actions.USER_ID_SUBMIT_FAILURE:
      return { ...state, submitting: false, error: { msg: action.data } }
    case actions.USER_ID_SUBMIT_SUCCESS:
      return {
        ...state,
        popup: true,
        popupText: action.data,
        data: action.data,
        otpToken: action.otpToken,
        isSendOtp: true,
        error: {}
      };
    //Stage 1: Enter Username

    //Resend Otp
    case actions.RESEND_OTP:
      return { ...state, otpToken: action.otpToken }
    case actions.RESEND_OTP_SUCCESS:
      return { ...state, popup: true, popupText: action.data }
    case actions.RESEND_OTP_FAILURE:
      return { ...state, popup: true, popupText: action.data }
    //Resend Otp

    //Stage 2: Enter OTP
    case actions.ENTER_OTP:
      error = (action.data.length > 6 || action.data === NaN)
      return { ...state, otp: action.data, error: { otp: error ? E_VALID_OTP : '' } };
    case actions.OTP_SUBMIT:
      error = !(state.otp && state.otp.length === 6);
      return { ...state, submitting: !error, error: { otp: error ? E_VALID_OTP : '' } };
    case actions.OTP_SUBMIT_FAILURE:
      return { ...state, submitting: false, error: { msg: action.data } }

    case actions.OTP_SUBMIT_SUCCESS:
      return {
        ...state,
        submitting: false,
        token: action.token,
        isCTCL: action.isCTCL,
        step: state.step + 1,
        error: {}
      }
    //Stage 2: Enter OTP

    //Stage 3: Forgot Password
    case actions.ENTER_OLDPASSWORD:
      error = validatePassword(action.data);
      return { ...state, oldpassword: action.data, error: { oldpassword: error } };
    case actions.ENTER_NEWPASSWORD:
      error = validatePassword(action.data);
      return { ...state, newpassword: action.data, error: { newpassword: error } };
    case actions.CONFIRM_PASSWORD:
      error = action.data !== state.newpassword;
      return { ...state, confirmpassword: action.data, error: { confirmpassword: error } };

    case actions.SUBMIT_PASSWORD:
      let passMatch = state.confirmpassword === state.newpassword;
      error = !(state.confirmpassword && passMatch)
      return {
        ...state,
        submitting: !error,
        error: error ? { msg: !passMatch ? E_PASSWORD_MATCH : E_PASSWORD_CHECK } : {}
      };
    case actions.NEW_PASSWORD_SUBMIT_FAILURE:
      return { ...state, submitting: false, error: { msg: action.data } };
    case actions.NEW_PASSWORD_SUBMIT_SUCCESS:
      return { ...state, isnewpasswordset: true, popup: true, popupText: action.data.msg };
    //Stage 3: Forgot Password

    //Stage 3.1: Change Password
    case actions.CHANGE_PASS_SUBMIT_FAILURE:
      return { ...state, submitting: false, error: { msg: action.data } };
    case actions.CHANGE_PASS_SUBMIT_SUCCESS:
      return {
        ...state,
        popup: true,
        popupText: actions.CHANGE_PASS_SUBMIT_SUCCESS,
        step: state.step + 1
      };
    //Stage 3.1: Change Password

    //Close popup
    case actions.POPUP_SUBMIT:
      return {
        ...state,
        submitting: false,
        popup: false,
        //Avoid step change on Resend OTP
        step: state.step != 1 ? state.step + 1 : state.step
      };
    //Close popup
  }
  return { ...state };
}

function ForgotPassword(props) {
  const {
    classes,
    match: {
      params: { username, step: propsStep }
    },
    user
  } = props;
  const {
    TITLES: { FORGOT_PASS },
    LABELS: { USER_ID_MOBILE_NO, SUBMIT },
    ERRORS: { E_VALID_USER_ID }
  } = strings;

  const [showImage, setShowImage] = useState(true);
  // const captchaValue = useRef();
  const captchaRef = useRef();
  const googleCaptchaRef = useRef();

  const [state, setState] = useReducer(reducerFunction, {
    ...initialState,
    user,
    username,
    step: Number(propsStep || 0)
    // step: 2
  });

  const { submitting } = state;
  // setState({ ...state, username });

  const handlesubmit = e => {
    e && e.preventDefault();
    // const captchaValidation = captchaRef && captchaRef.current && captchaRef.current.validate();
    // captchaValue.current = captchaValidation;
    // if (!captchaValidation) {
    //   return;
    // }
    const googleCaptchaVal = googleCaptchaRef.current.getValue();
    setState({ type: actions.USER_ID_SUBMIT/* , stage1: stage1 */ });
    if (state.username && state.username.length <= 25 /* && captchaValue.current */ && googleCaptchaVal != '') {
      stage1();
    }
    // return false;
  };
  const handleonchange = e => {
    setState({
      type: actions.USERNAME_EDIT,
      data: e.target.value
    });
  };
  const onCaptchaChange = val => {
    setState({ type: actions.USERNAME_EDIT, data: state.username, captchaState: val, googleCaptchaVal: val });
    // captchaValue.current = val;
  };
  const handlepopup = () => {
    alertActions.clear();
    setState({ type: actions.POPUP_SUBMIT });
  };
  const stage1 = () => {
    makeCall({
      stg: "101",
      clientCode: state.username,
      otpChannel: "web",
      captchaResponse: googleCaptchaRef.current.getValue(),//+"pat",
    }).then(useEventResp);
  };
  const stage2 = () => {
    makeCall({ stg: "201", clientCode: state.username, otp: state.otp, otpToken: state.otpToken }).then(
      useEventForOtp
    );
  };
  const stage3 = () => {
    makeCall({
      stg: "301",
      authToken: state.token,
      newPassword: state.newpassword,
      confirmPassword: state.confirmpassword,
      isCTCL: state.isCTCL || null
    }).then(useEventNewPasswd);
  };
  const changePassReq = () => {
    // debugger
    // alert('implement this');
    // return;
    makeCall({
      oldPassword: state.oldpassword,
      newPassword: state.newpassword,
      confirmPassword: state.confirmpassword
    }, `${config.endpoint}${config.changePwd}`,
      (user ? { headers: { Authorization: `Bearer ${user?.access_token || ''}` } } : {})).then(useEventChangePass);
  };
  const Stageresend = () => {
    let uri = undefined;
    let payloadobj = {
      otpToken: state.otpToken
    };
    uri = `${config.endpoint}${config.resendotp}`;
    makeCall(payloadobj, uri).then(useEventForResendOtp).catch(useEventForResendOtp);
  };

  const respFunc = resp => {
    if (resp && resp.data && resp.data.success) {
      setState({
        type: actions.USER_ID_SUBMIT_SUCCESS,
        data: resp.data.success.msg,
        otpToken: resp.data.success.otpToken
      });
    }
    else {
      googleCaptchaRef.current.reset();
      setState({
        type: actions.USER_ID_SUBMIT_FAILURE,
        data: resp && resp.data && resp.data.error ? resp.data.error.msg : E_VALID_USER_ID
      });
    }
  };

  const OTPrespFunction = resp => {
    if (resp.data.error) {
      setState({ type: actions.OTP_SUBMIT_FAILURE, data: resp.data.error.msg });
    } else {
      setState({
        type: actions.OTP_SUBMIT_SUCCESS,
        data: resp.data.success.msg,
        token: resp.data.success.token,
        isCTCL: resp.data.success.isCTCL,
      });
    }
  };
  const NEWpasswdrespFunc = resp => {
    // debugger
    if (resp.data.error) {
      setState({
        type: actions.NEW_PASSWORD_SUBMIT_FAILURE,
        data: resp.data.error.msg
      });
    } else {
      setState({
        type: actions.NEW_PASSWORD_SUBMIT_SUCCESS,
        data: { msg: resp.data.success.msg, isPinSet: false }
      });
    }
  };
  const changePassRespFunc = resp => {
    // debugger
    if (resp.data.error) {
      setState({
        type: actions.CHANGE_PASS_SUBMIT_FAILURE,
        data: resp.data.error.msg ? resp.data.error.msg : resp.data.error
      });
    } else {
      deleteCookie("t_token")
      setState({
        type: actions.CHANGE_PASS_SUBMIT_SUCCESS,
        data: { ...resp.data.success.msg, isPinSet: false }
      });
    }
  };
  const resendotpRespFunc = resp => {
    if (resp && resp.data && resp.data.success) {
      // alert("OTP resent successfully");
      setState({
        type: actions.RESEND_OTP_SUCCESS,
        data: resp.data.success.msg
      });
      otpSuccessEvent.sendMessage();
    } else {
      let errMsg = resp && resp.data && resp.data.error ? resp.data.error : "Something went wrong";
      let errorCode = resp && resp.data && resp.data.errorCode ? resp.data.errorCode : 0;
      // alert(errMsg);
      setState({
        type: actions.RESEND_OTP_FAILURE,
        data: errMsg
      });
      if (errorCode == 1751 || errorCode == 1752 || errorCode == 1753 || errorCode == 1754) {
        alert(errMsg);
        goToLogin(props.history);
      } else {
        otpErrorEvent.sendMessage();
      }
    }
  };

  const useEventResp = useEventCallback(respFunc, [state, setState]);
  const useEventForOtp = useEventCallback(OTPrespFunction, [state, setState]);
  const useEventNewPasswd = useEventCallback(NEWpasswdrespFunc, [state, setState]);
  const useEventChangePass = useEventCallback(changePassRespFunc, [state, setState]);
  const useEventForResendOtp = useEventCallback(resendotpRespFunc, [state, setState]);

  function getStepContent(step) {
    // debugger
    switch (Number(step)) {
      // case 0:
      //   return < ForgotPassword/>
      case 1:
        // debugger
        return (
          <OtpForm
            state={state}
            setState={setState}
            stage2={stage2}
            Stageresend={Stageresend}
            {...props}
          />
        );
      case 2:
        return (
          <ChangepassForm state={state} setState={setState} callBack={user ? changePassReq : stage3} {...props} />
        );
      case 3:
      case 6:
        // debugger
        // if (user)
        //   props.history.replace("/setpin");
        // else
        // props.history.replace("/");
        goToLogin(props.history);
        break;
      case 4:
        return <SetPin />;
      case 5:
        setReferer();
        return (
          <ChangepassForm
            state={state}
            setState={setState}
            callBack={changePassReq}
            {...props}
            user={{ user: "abc" }}
          />
        );
    }
  }

  return (
    <>
      {getStepContent(state.step)}

      {state.step == 0 && (
        <AuthContainer formtype="forgotpassword" user>
          <Box className={classes.formBox} style={{ height: "100%" }}>
            <div style={{ width: "100%" }}>
              <Typography gutterBottom className={classes.formtitle}>
                {FORGOT_PASS}
              </Typography>

              {/* <InputPaper
              autoFocus
              inputtype="text"
              value={state && state.username}
              placeholder={USER_ID_MOBILE_NO}
              name="username"
              error={state.error.username ? true : false}
              handler={handleonchange}
              image="../images/clientid.svg"
              alt_text="client-icon"
              errorPos='top'
              errorMsg={!!state.error.username ? state.error.username : null}
              disabled={submitting}
            />

            <Typography
              className={classes.errormsg}
              variant="caption"
              display="block"
              gutterBottom
            >
              {state.error.msg}
            </Typography> */}

              <FormControl className={classes.formControl}>
                <Typography className={classes.fieldTitle}>{USER_ID_MOBILE_NO}</Typography>
                <CssOutlinedInput
                  id="username"
                  type={'text'}
                  name="username"
                  fullWidth
                  value={username}
                  onChange={handleonchange}
                  placeholder={`Enter your ${USER_ID_MOBILE_NO}`}
                  variant="outlined"
                  disabled={submitting}
                  autoFocus
                  error={state.error.username ? true : false}
                  inputProps={{
                    'aria-label': 'Client Id/Mobile No',
                  }}
                />
                {!!state.error.username ? <Typography variant="body2" className={classes.errorText}>{state?.error?.username || ''}</Typography> : null}
              </FormControl>

              <ReCAPTCHA
                ref={googleCaptchaRef}
                className={classes.captcha}
                style={{ display: "inline-block", margin: "24px 4px" }}
                size="normal"
                // size="invisible"
                sitekey="6LcaCSkeAAAAAHe_pYkugmdMro_bmzcoFk8HiCZj"
                onChange={onCaptchaChange}
              />
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
              <Typography
                className={classes.errormsg}
                variant="caption"
                display="block"
                gutterBottom
              >
                {state.error.msg || " "}
              </Typography>
              <Button
                variant="contained"
                className={classes.blueButton}
                onClick={handlesubmit}
                type="submit"
                disabled={submitting}
              >
                Next
                {submitting ? <CircularProgress size="15" className={classes.spinner} /> : ""}
              </Button>
            </div>
          </Box>
        </AuthContainer>
      )}

      <CommonPopup
        // openState={true}
        openState={state.popup}
        popupText={state.popupText}
        handleClick={handlepopup}
      ></CommonPopup>
    </>
  );
}

function mapStateToProps(state) {
  const { user, password } = state.authentication;
  return {
    user,
    password
  };
}
const connectedForgotPassword = connect(mapStateToProps)(
  withStyles(Styles)(ForgotPassword)
);
export { connectedForgotPassword as ForgotPassword };

